import jwt_decode from "jwt-decode";
import { isEmpty } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { usePolling } from "../component/usePolling";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import moment from "moment/moment";
const HomeMatchList = () => {
  const [list, setList] = useState([]);
  const getData = async () => {
    const { status, data } = await apiGet(apiPath.seriesList, {
      type: "live",
      userId: !isEmpty(localStorage.getItem("token"))
        ? jwt_decode(localStorage.getItem("token"))?.user?._id
        : "",
    });
    if (data?.success) {
      let newResult = data?.results
        ?.map((res) => {
          return res?.matchList?.map((item) => {
            return { ...item, seriesName: res?.seriesName };
          });
        })
        .flat();
      setList(newResult);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div className="matches-box">
      {list?.slice(0, 8)?.map((res) => {
        let teamName = res?.eventName?.split(" v ");
        return (
          <div className="match-item">
            <div className="row flex-nowrap no-gutters">
              <div className="col col-12">
                <div
                  tabIndex={0}
                  className="mobile-match-card v-card v-card--link v-sheet theme--dark"
                >
                  <div className="row">
                    <div className="ml-2 mt-2 mb-2 font-weight-bold d-flex col col-12">
                      <div
                        className={
                          res?.status == "active" ? "matchUp-NS" : "matchUp"
                        }
                      >
                        <div>
                          {res?.status != "active" ? "In Play" : "Upcoming"}
                        </div>
                      </div>
                      <span className="ml-2 leagueName">{res?.seriesName}</span>
                    </div>
                  </div>
                  <div className="row mobile-detail-wrapper no-gutters">
                    <div className="mobile-match-details match-date pl-3 pt-1 col col-12">
                      {moment(res?.eventDateTime).format(
                        "MMM DD, YYYY HH:mm:ss",
                      )}
                    </div>
                    <div className="mobile-match-details col col-12">
                      <div className="row no-gutters">
                        <div className="pa-0 col col-6">
                          <span
                            className="team-title"
                            style={{ paddingLeft: "10px" }}
                          >
                            {teamName[0]}
                          </span>
                        </div>
                        <div className="pa-0 d-flex col col-4">
                          <span className="team-title">-</span>
                        </div>
                      </div>
                    </div>
                    <div className="mobile-match-details col col-12">
                      <div className="row no-gutters">
                        <div className="pa-0 col col-6">
                          <span
                            className="team-title"
                            style={{ paddingLeft: "10px" }}
                          >
                            {teamName[1]}
                          </span>
                        </div>
                        <div className="pa-0 col col-4">
                          <span className="team-title">-</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default HomeMatchList;
